import React from 'react';
import PropTypes from 'prop-types';

import Close from '@zg-rentals/multibrand-ui/lib/icons/Close';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import DatePicker from '@zg-rentals/multibrand-ui/lib/DatePicker';
import Col from '@zg-rentals/multibrand-ui/lib/Col';

const propTypes = {
    title: PropTypes.string,
    value: PropTypes.any,
    handleClose: PropTypes.func,
    isFilterOpen: PropTypes.bool,
    handleChange: PropTypes.func,
    disableFuture: PropTypes.bool,
    isDateEnabled: PropTypes.func,
    filters: PropTypes.object.isRequired,
};

const defaultProps = {
    title: '',
    value: null,
    handleClose: () => { },
    isFilterOpen: false,
    handleChange: () => { },
    disableFuture: false,
    isDateEnabled: undefined,
};

const DateFilterPill = ({
    title,
    value,
    handleClose,
    isFilterOpen,
    handleChange,
    defaultValue,
    keyName,
    disableFuture,
    isDateEnabled,
    filters,
}) => {
    if (!isFilterOpen && !value) return null;
    const validateTimeRange = (date) => {
        if (isDateEnabled) {
            return isDateEnabled(new Date(date), filters);
        }
        return true;
    };

    if (isFilterOpen) {
        return (
            <Col sm={12} md={6} lg={4}>
                <div className="BillingFilterPill">
                    <DatePicker
                        label={title}
                        closeOnSelectDate={true}
                        id={keyName}
                        disablePast={false}
                        viewDate={new Date(defaultValue)}
                        onChange={(e => handleChange(e.target.value))}
                        value={value}
                        disableFuture={disableFuture}
                        isDateEnabled={validateTimeRange}
                    />
                </div>
            </Col>
        );
    }

    return (
        <Col sm={6} md={4}>
            <div className="BillingFilterPill">
                <Text className="BillingFilterPill-header">{title}</Text>
                <Text>{(new Date(value)).toLocaleDateString()}</Text>
                <div className="BillingFilterPill-close" onClick={() => handleClose(null)}>
                    <Close size={12} />
                </div>
            </div>
        </Col>
    );
};

DateFilterPill.propTypes = propTypes;
DateFilterPill.defaultProps = defaultProps;

export default DateFilterPill;
